import { fetchGetSharedFunctionality } from '@iwoca/lapi-client/iwocapay';

const isDevelopmentBuild = import.meta.env.MODE === 'development';

export function registerStateKey(stateKey: string) {
  if (isDevelopmentBuild) {
    console.log('[DEV] Registering statekey in FullStory', stateKey);
    return;
  }

  window.FS?.identify(stateKey, { stateKey_str: stateKey });
}

export type SharedFunctionality = NonNullable<
  NonNullable<
    Parameters<typeof fetchGetSharedFunctionality>[0]['query']
  >['functionalities']
>[number];

export function registerSharedFunctionalities(
  stateKey: string,
  sharedFunctionalities: Partial<Record<SharedFunctionality, boolean>>,
) {
  if (isDevelopmentBuild) {
    console.log(
      '[DEV] Registering shared functionalities in FullStory',
      sharedFunctionalities,
    );
    return;
  }

  window.FS?.identify(
    stateKey,
    Object.fromEntries(
      Object.entries(sharedFunctionalities).map(
        ([sharedFunctionality, enabled]) => [
          `${sharedFunctionality}_bool`,
          enabled,
        ],
      ),
    ),
  );
}
